function DriversTabController(__env) {
  const ctrl = this;
  const env = __env;

  ctrl.$onInit = () => {
    ctrl.hasClockAndMode = env.profile !== 'VALE';
  };
}

angular
  .module('configuration-management.module')
  .controller('DriversTabController', DriversTabController);